import './AreaIndicatorDashboardsCounter.css';

import React from 'react';
import FieldComponent from '../../../b2b-common/FieldComponent';
import Counter from '../../../b2b-common/Counter';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import { Box } from '@mui/material';
import { getIconWithTooltip } from '../helper';
import { InfoOutlined } from '@mui/icons-material';
import DashboardLink from '../../../b2b-reporting/components/DashboardLink';
import InfoWindow from '../../../b2b-common/InfoWindow';

const AreaIndicatorDashboardsCounter = ({ dashboardsData }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const [isInfoOpen, setIsInfoOpen] = React.useState(false);
    const secondsOpen = 5;

    const handleClickOnMoreInfo = () => {
        setIsInfoOpen(!isInfoOpen);
    };

    const handleCloseInfo = () => {
        setIsInfoOpen(false);
    };

    if (!dashboardsData || dashboardsData.length === 0)
        return null

    return (
        <FieldComponent
            label={t('Dashboards')}
            component={
                <Box display='flex' alignItems='center' gap={0.5} position={'relative'}>
                    <Counter
                        count={dashboardsData ? dashboardsData.length : 0}
                        minDigits={2}
                    />
                    {getIconWithTooltip(InfoOutlined, {}, t('Click for more information on dashboard usage'), null, handleClickOnMoreInfo)}
                    {isInfoOpen && (
                        <InfoWindow
                            top='30px' right='30px'
                            width='350px' minHeight='100px'
                            windowTitle={t('Dashboards where indicator is included:')}
                            windowContent={dashboardsData.map(dashboard => (
                                <DashboardLink key={dashboard.dashboardId} dashboard={dashboard} />
                            ))}
                            handleClose={handleCloseInfo}
                            className='area-indicator-dashboards-counter-information-window'
                            secondsOpen={secondsOpen}
                        />
                    )}
                </Box>
            }
            className='area-indicator-dashboards-counter'
        />
    );
};

export default AreaIndicatorDashboardsCounter;